// Selected organization id, persisted per browser session like the auth token.
// Ids are TSID strings; they exceed Number precision and must never be converted.

const STORAGE_KEY = 'selected_organization';

let inMemoryId: string | null = null;

export function getSelectedOrganizationId(): string | null {
  if (inMemoryId) return inMemoryId;
  try {
    inMemoryId = sessionStorage.getItem(STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable (privacy mode). Fall back to memory only.
  }
  return inMemoryId;
}

export function setSelectedOrganizationId(id: string | null): void {
  inMemoryId = id;
  try {
    if (id) {
      sessionStorage.setItem(STORAGE_KEY, id);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Ignore storage errors; we still keep in-memory value.
  }
}
